export default __webpack_public_path__ + "static/media/react.fd3d4986.png";